import { cn } from '@/lib/utils';
import { FC } from 'react';
import { InputContainer } from '../InputContainer';
import { InputProps, withField } from '../withField';

export interface EmailInputProps {
  placeholder?: string;
}

export const EmailInput: FC<InputProps<string> & EmailInputProps> = ({
  onChange,
  value,
  id,
  placeholder,
  autofocus
}) => {
  return (
    <InputContainer className={cn('px-3 py-2')}>
      <input
        autoFocus={autofocus}
        value={value}
        onChange={e => {
          onChange(e.target.value);
        }}
        type={'email'}
        id={id}
        className="placeholder:text-secondary-std block flex-1 border-0 bg-transparent p-0 text-sm placeholder:opacity-60 focus:ring-0 sm:leading-6"
        placeholder={placeholder}
      />
    </InputContainer>
  );
};

export const EmailField = withField<string, EmailInputProps>(EmailInput);
